export default __webpack_public_path__ + "static/media/views.3f5c011a.svg";